import React, { useState, useEffect } from "react";
import { CardSection } from "../../../components/CardSection";
import { StyledSection4 } from "./style";
import { Util } from "../../../util/Util";
import { API } from "../../../apis/dashboard.api";

import useRegionStore from "../../../store/useRegionStore";
import useDateRangeStore from "../../../store/useDateRangeStore";
import { BarGraph } from "../../../components/Graph/BarGraph";
import { ALL_REGIONS } from "../../../consts/const";

export const Section4 = () => {
  const { periodStartDate, periodEndDate } = useDateRangeStore();
  const { receiveData, setReceiveData, selectedRegionList } = useRegionStore();
  const [chartsData, setChartsData] = useState([]);

  useEffect(() => {
    function fetchData() {
      if (!selectedRegionList || selectedRegionList.length === 0) {
        return;
      }
      const formattedStartDate = Util.formatDate(periodStartDate);
      const formattedEndDate = Util.formatDate(periodEndDate);

      let departmentIds;
      if (selectedRegionList.indexOf("ALL") > -1) {
        departmentIds = [];
      } else {
        departmentIds = selectedRegionList;
      }

      API.getPeriodReceiveCount({
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        departmentIds,
      })
        .then((receiveCountData) => {
          if (receiveCountData) {
            setReceiveData(receiveCountData);
          }
        })
        .catch((error) => {
          console.error("오류 :", error);
        });
    }

    fetchData();
  }, [periodStartDate, periodEndDate, selectedRegionList, setReceiveData]);

  useEffect(() => {
    if (!receiveData) return;
    if (!selectedRegionList) return;
    let newChartData = {};
    for (let region of ALL_REGIONS) {
      if (selectedRegionList.includes(region.value)) {
        newChartData = {
          ...newChartData,
          [region.label]: Util.getDateRange(periodStartDate, periodEndDate).map(
            (date) => ({
              day: date,
              count: 0,
            })
          ),
        };
      } else continue;
    }
    for (let department of receiveData) {
      const chartData = department.receivedDataList.map((data) => ({
        day: data.detectedDay,
        count: data.receivedDataCnt,
      }));
      const label = department.departmentName.replace("국토관리사무소", "");
      newChartData = {
        ...newChartData,
        [label]: Util.mergeArrays(newChartData[label], chartData, "day"),
      };
    }
    setChartsData(newChartData);
  }, [receiveData]);

  return (
    <StyledSection4>
      {chartsData && Object.keys(chartsData).length > 0 && (
        <div className="section4-container">
          <CardSection title="기간별 데이터 수신 현황" icon="Histogram">
            <BarGraph
              data={chartsData}
              xKey="day"
              yKey={[{ label: "수신된 데이터 개수", key: "count" }]}
              yLabel="개수"
              unit="개"
              multiGraphMode={true}
            />
          </CardSection>
        </div>
      )}
    </StyledSection4>
  );
};
